import { Loader } from '@ksyos/design-system';
import { styled } from 'styled-components';

export const CenteredLoader = styled(Loader)`
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
`;
